import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { CONTACT_EMAIL } from '@/data/contact'

export function PrivacyPage() {
  const navigate = useNavigate()
  return (
    <div className="min-h-screen bg-[#060a13] text-gray-100">
      <div className="max-w-md mx-auto px-5 pt-5 pb-24">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-gray-400 mb-6 cursor-pointer hover:text-gray-200 transition-colors"
        >
          <span style={{ color: '#94a3b8' }}><ArrowLeft className="w-4 h-4" /></span>
          <span className="text-[14px]">Retour</span>
        </button>

        <h1 className="text-[24px] font-bold text-white mb-2">Politique de confidentialité</h1>
        <p className="text-[12px] text-gray-500 mb-8">Dernière mise à jour : 14 mai 2026</p>

        <section className="mb-6">
          <h2 className="text-[16px] font-bold text-white mb-2">Données collectées</h2>
          <p className="text-[13px] text-gray-300 leading-relaxed">
            Zeyone Fit collecte les données que tu renseignes via le wizard d'inscription
            (genre, âge, taille, poids, niveau, objectif) et celles produites par ton usage
            de l'app : séances réalisées, RPE, score Hooper, pesées, charge d'entraînement.
            Ces données sont nécessaires au fonctionnement du coaching personnalisé.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-[16px] font-bold text-white mb-2">Cookies et trackers</h2>
          <p className="text-[13px] text-gray-300 leading-relaxed mb-2">
            On utilise <span className="text-cyan-400">PostHog</span> (hébergé en Union
            européenne) pour mesurer l'usage de l'app de façon anonyme et améliorer le
            produit. Aucun tracker publicitaire, aucune revente de données.
          </p>
          <p className="text-[13px] text-gray-300 leading-relaxed">
            Le tracking n'est activé que si tu donnes ton accord via le bandeau de
            consentement. Tu peux changer d'avis à tout moment en effaçant les données
            locales de l'app dans ton navigateur.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-[16px] font-bold text-white mb-2">Paiement</h2>
          <p className="text-[13px] text-gray-300 leading-relaxed">
            Les paiements sont traités par <span className="text-cyan-400">Stripe</span>.
            Aucune information de carte bancaire ne transite ni n'est stockée sur nos serveurs.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-[16px] font-bold text-white mb-2">Tes droits (RGPD)</h2>
          <p className="text-[13px] text-gray-300 leading-relaxed mb-2">
            Conformément au RGPD, tu disposes d'un droit d'accès, de rectification, de
            suppression et de portabilité de tes données. Pour exercer ces droits, contacte-nous
            par email.
          </p>
          <p className="text-[13px] text-gray-300 leading-relaxed">
            La suppression du compte entraîne la suppression de toutes les données associées,
            sauf obligations légales de conservation (facturation Stripe : 10 ans).
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-[16px] font-bold text-white mb-2">Hébergement</h2>
          <p className="text-[13px] text-gray-300 leading-relaxed">
            Données stockées sur <span className="text-cyan-400">Supabase</span> (région
            Union européenne). Front hébergé sur <span className="text-cyan-400">Cloudflare Pages</span>.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-[16px] font-bold text-white mb-2">Contact</h2>
          <p className="text-[13px] text-gray-300 leading-relaxed">
            Pour toute question relative à tes données personnelles :{' '}
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="text-cyan-400 underline underline-offset-2 hover:text-cyan-300"
            >
              {CONTACT_EMAIL}
            </a>
          </p>
        </section>
      </div>
    </div>
  )
}
